import theme from '../../../lib/theme';

const { corners, shadows, scale, colors, media, layouts } = theme;

export default () => ({
  link: {
    textDecoration: 'none !important',

    '&:hover .Story__title': {
      textDecoration: 'underline',
      color: colors.sas.primary,
    },

    '&:hover .Story__image': {
      boxShadow: shadows.lowest,
    },
  },

  teaser: {
    ...layouts.spacedColumn('s'),
    maxWidth: '100%',
    flex: '1 0',
  },

  category: {
    textDecoration: 'none !important',
    fontSize: scale.xs,
    fontWeight: 500,

    '&:hover': {
      color: `${colors.sas.primary}`,
      textDecoration: 'underline',
    },
  },

  bottom: {
    ...layouts.spacedRow('s'),

    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },

  container: {
    '> a': {
      ...layouts.spacedColumn('xxs'),
      alignItems: 'center',
      justifyContent: 'center',
      gap: '0.5em',
      cursor: 'pointer',

      '&:hover': {
        textDecoration: 'none',

        '.Story__title': {
          textDecoration: 'underline',
          color: colors.sas.primary,
        },
        '.Story__image': {
          boxShadow: shadows.lowest,
        },
        '.Story__excerpt': {
          textDecoration: 'none !important',
        },
  
      },

      [media.s.up]: {
        ...layouts.spacedRow('xxs'),
        alignItems: 'flex-start',
      },
    },
  },

  slot: {
    display: 'flex',
    flex: '0 0 100%',
    maxWidth: '100%',
    flexDirection: 'column',
    margin: `${scale.xs} 0 0 0 !important`,

    [media.s.up]: {
      flex: '0 0 70%',
      maxWidth: '70%',
      margin: `0 !important`,
    },
  },

  text: {
    ...layouts.spacedColumn('xxs'),
  },

  imageContainer: {
    width: '100%',
    minWidth: '100%',
    flex: '1 0 100%',

    [media.s.up]: {
      width: '30%',
      minWidth: '30%',
      flex: '0 0 30%',
    },
  },

  image: {
    backgroundColor: colors.grey,
    width: '100%',
    border: `1px solid ${colors.grey}`,
  },

  title: {
    transition: 'all 150ms linear',
    display: 'none',

    [media.s.up]: {
      display: 'block',
      fontSize: '16px !important',
      fontWeight: '500 !important',
      margin: '0 !important',
      lineHeight: 'unset !important',
    },
  },

  excerpt: {
    margin: `${scale.xxxs} 0 0 0 !important`,
    lineHeight: '1rem',

    '> span': { 
      fontSize: '13px !important',
    },
  },

  titleMobile: {
    display: 'block',
    marginBottom: scale.xs,

    [media.s.up]: {
      display: 'none',
    },
  },
});
